<div class="empty-block">
  <div>
    <p>
      <strong>
        {{ title }}
      </strong>
    </p>
    <ng-content />
    <a routerLink="/gallery" class="button button_dark button_standard w100">
      Explore images
    </a>
  </div>
</div>
